// src/screens/LoginScreen.js
import React, { useState } from 'react';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../firebase/config';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { FaArrowLeft } from 'react-icons/fa';
import fondo from '../assets/imagen6.jpeg';

const APP_PRIMARY = '#b03060';

const LoginScreen = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [mensajeError, setMensajeError] = useState('');
  const [mensajeExito, setMensajeExito] = useState('');
  const [cargando, setCargando] = useState(false);

  const handleLogin = async (e) => {
    if (e) e.preventDefault();
    setMensajeError('');
    setMensajeExito('');
    if (!email || !password) {
      setMensajeError('Por favor completa todos los campos.');
      return;
    }

    setCargando(true);
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email.trim(), password);
      const user = userCredential.user;

      const docRef = doc(db, 'usuarios', user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        const esAdmin = data.isAdmin === true || data.rol === 'admin';
        const estado = (data.subscriptionStatus || data.estado || '').toLowerCase();
        const estaInactivoOEliminado =
          data.eliminado === true ||
          data.isDeleted === true ||
          data.status === 'deleted' ||
          estado === 'inactivo' ||
          estado === 'eliminado' ||
          estado === 'expired' ||
          estado === 'vencido';

        if (esAdmin) {
          navigate('/admin');
          return;
        }

        if (estaInactivoOEliminado) {
          navigate('/plans');
          return;
        }

        if (estado === 'pending_payment' || estado === 'pending' || estado === 'payment_sent') {
          navigate('/pago-pendiente');
          return;
        }

        navigate('/home');
      } else {
        navigate('/plans');
      }
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      if (
        error.code === 'auth/invalid-credential' ||
        error.code === 'auth/user-not-found' ||
        error.code === 'auth/wrong-password'
      ) {
        setMensajeError('Correo o contraseña incorrectos.');
      } else if (error.code === 'auth/too-many-requests') {
        setMensajeError('Demasiados intentos fallidos. Intenta más tarde.');
      } else {
        setMensajeError('Error al iniciar sesión. Inténtalo nuevamente.');
      }
    } finally {
      setCargando(false);
    }
  };

  return (
    <div
      style={{
        backgroundImage: `url(${fondo})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh',
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: "'Poppins', sans-serif"
      }}
    >
      <div style={styles.overlay}>
        <div style={styles.card}>
          <button onClick={() => navigate('/')} style={styles.backButton}>
            <FaArrowLeft size={13} /> Volver atrás
          </button>

          <h2 style={styles.title}>Iniciar Sesión</h2>

          {mensajeError && <div style={styles.errorBox}>{mensajeError}</div>}
          {mensajeExito && <div style={styles.successBox}>{mensajeExito}</div>}

          <form onSubmit={handleLogin} style={styles.form}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Correo electrónico</label>
              <input
                type="email"
                placeholder="ejemplo@correo.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={styles.input}
                required
              />
            </div>

            <div style={styles.inputGroup}>
              <label style={styles.label}>Contraseña</label>
              <input
                type="password"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={styles.input}
                required
              />
            </div>

            <button
              type="submit"
              disabled={cargando}
              style={{
                ...styles.button,
                opacity: cargando ? 0.7 : 1,
                cursor: cargando ? 'not-allowed' : 'pointer'
              }}
            >
              {cargando ? 'Ingresando...' : 'Ingresar'}
            </button>
          </form>

          <div style={styles.linkContainer}>
            <button
              type="button"
              onClick={() => navigate('/reset-password')}
              style={styles.linkButton}
            >
              ¿Olvidaste tu contraseña?
            </button>
          </div>

          <div style={{ ...styles.linkContainer, marginTop: 12 }}>
            <span style={{ color: '#475569', fontSize: 13 }}>¿No tienes cuenta? </span>
            <button
              type="button"
              onClick={() => navigate('/plans')}
              style={{ ...styles.linkButton, fontWeight: '700' }}
            >
              Elige un plan
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// ========== ESTILOS ==========
const styles = {
  overlay: {
    backgroundColor: 'rgba(15, 23, 42, 0.45)',
    backdropFilter: 'blur(3px)',
    WebkitBackdropFilter: 'blur(3px)',
    minHeight: '100vh',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 16px',
    boxSizing: 'border-box'
  },
  card: {
    backgroundColor: 'rgba(255, 255, 255, 0.92)',
    backdropFilter: 'blur(16px)',
    WebkitBackdropFilter: 'blur(16px)',
    width: '100%',
    maxWidth: 420,
    borderRadius: 22,
    boxShadow: '0 12px 40px rgba(0, 0, 0, 0.18)',
    padding: '32px 28px',
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    border: '1px solid rgba(255, 255, 255, 0.7)'
  },
  backButton: {
    background: 'none',
    border: 'none',
    color: APP_PRIMARY,
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: '600',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    alignSelf: 'flex-start',
    marginBottom: 16,
    padding: 0
  },
  title: {
    color: '#1e293b',
    marginBottom: 20,
    textAlign: 'center',
    fontSize: 24,
    fontWeight: '700',
    letterSpacing: '-0.3px'
  },
  errorBox: {
    backgroundColor: '#fef2f2',
    color: '#dc2626',
    border: '1px solid #fecaca',
    padding: '10px 14px',
    borderRadius: 10,
    marginBottom: 16,
    fontSize: 13,
    textAlign: 'center'
  },
  successBox: {
    backgroundColor: '#f0fdf4',
    color: '#15803d',
    border: '1px solid #bbf7d0',
    padding: '10px 14px',
    borderRadius: 10,
    marginBottom: 16,
    fontSize: 13,
    textAlign: 'center'
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
    width: '100%'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6
  },
  label: {
    fontSize: 12,
    fontWeight: '600',
    color: '#475569'
  },
  input: {
    padding: '12px 14px',
    width: '100%',
    border: '1.5px solid #e2e8f0',
    borderRadius: 10,
    fontSize: 14,
    boxSizing: 'border-box',
    outline: 'none',
    color: '#1e293b',
    backgroundColor: '#ffffff',
    transition: 'border-color 0.2s ease',
    fontFamily: 'inherit'
  },
  button: {
    marginTop: 6,
    padding: '13px',
    backgroundColor: APP_PRIMARY,
    color: '#ffffff',
    border: 'none',
    borderRadius: 50,
    cursor: 'pointer',
    width: '100%',
    fontSize: 14,
    fontWeight: '700',
    boxShadow: '0 4px 14px rgba(176, 48, 96, 0.3)',
    transition: 'all 0.2s ease'
  },
  linkContainer: {
    marginTop: 16,
    textAlign: 'center'
  },
  linkButton: {
    background: 'none',
    border: 'none',
    color: APP_PRIMARY,
    cursor: 'pointer',
    fontSize: 13,
    fontWeight: '600',
    padding: 0,
    textDecoration: 'none'
  }
};

export default LoginScreen;